module.exports = __webpack_public_path__ + "static/img/线下活动-集市活动.b6e4b2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10011/线下活动-集市活动.png
// module id = wOAh
// module chunks = 1